import { useMemo } from 'react';
import { useRequestController } from './useRequestController.ts';
import { parseJsonSafely } from '../../ChatPage/utils';
import { orderBy } from 'lodash-es';

/**
 * 海报灵感模板数据请求 hook
 * 获取产品配置的海报灵感模板列表
 */

export const usePosterTemplateData = () => {
  const { data, loading } = useRequestController({
    method: 'POST',
    url: `/api/v1/permission/rainbow`,
    refreshDeps: useMemo(() => ({ key: '', group: 'agent.poster_template' }), []),
    // 默认30分钟不发起请求
    staleTime: 1800000,
    cacheKey: 'home-poster_template_list',
  });
  const realData = useMemo(() => {
    const dataSource = data?.rows?.map((row) => {
      const parsedValue = parseJsonSafely(row.value);
      return {
        ...row,
        ...parsedValue || {},
      };
    });
    const sortData = orderBy(dataSource, ['sort'], ['asc']);
    return sortData;
  }, [data?.rows]);
  return {
    data: realData,
    loading,
  };
};

